import { RECEIVE_RECORDS, REMOVE_RECORDS, REMOVE_ALL_RECORDS, UPDATE_RECORDS, 
	LOADING_RECORDS, CLEAR_LOADING_RECORDS, INVALIDATE_CACHE } from "lib/shared/ActionUtility";

export function buildRecordReducer(key, options = {}) {
	var idKey = options.idKey || "id";

	var initialState = { loading: {}, cached: [], totals: {}, pages: {} };

	return (state = initialState, action = {}) => {
		switch (action.type) {

		case LOADING_RECORDS:
			if (key in action) {
				// Makes the key as being loading
				var newLoading = _.extend({}, state.loading, { [action[key]]: true });
				return _.extend({}, state, { loading: newLoading });

			}; break;

		case CLEAR_LOADING_RECORDS:
			if (key in action) {
				return _.extend({}, state, { loading: {}});

			}; break;


		case RECEIVE_RECORDS:
			if (key in action) {

				var mergedRecords = _.map(action[key], (item) => {
					var existingRecord = state[item[idKey]];
					if (existingRecord) {
						return _.extend({}, existingRecord, item);
					} else {
						return item;
					}
				});

				// Adds/replaces existing records with the new records
				var byID = _.indexBy(mergedRecords, idKey);

				if (action.metaReducer == key) {
					if (action.loadingKeys) {
						var newLoading = _.omit(state.loading, action.loadingKeys);
						state = _.extend({}, state, { loading: newLoading })
					}

					if (action.cache) {
						var newCached = state.cached.concat(action.cache);
						state = _.extend({}, state, { cached: newCached })
					}

					if (action.totals) {
						var newTotals = _.extend({}, state.totals, action.totals);
						state = _.extend({}, state, { totals: newTotals })
					}

					if (action.pagination) {
						var newPages = _.clone(state.pages);
						var pageKey = action.pagination.key;
						var pageIDs = _.pluck(mergedRecords, "id");

						newPages[pageKey] = _.extend({}, 
							newPages[pageKey], { [action.pagination.page]: pageIDs })

						state = _.extend({}, state, { pages: newPages })

						if (action.noMorePages) {
							state = _.extend({}, state, {noMorePages: {[action.pagination.key]:true}})
						}
					}

				}

				return _.extend({}, state, byID);
			}; break;

		case REMOVE_RECORDS:
			if (key in action) {
				// Filter out the IDs provided in action[key]
				return _.omit(state, action[key]);
			}; break;

		case REMOVE_ALL_RECORDS:
			if (key in action && action[key]) {
				return initialState;
			}

		case UPDATE_RECORDS:
			if (key in action) {
				var IDs = new Set(_.map(action[key], String));
				// Filter out the IDs provided in action[key]
				return _.mapObject(state, (x, id) => {
					return IDs.has(id) ? _.extend({}, x, action.update) : x;
				});
			}; break;

		case INVALIDATE_CACHE:
			if (key in action) {
				return _.extend({}, state, { cached: [] });
			}; break;
		}

		return state;
	}
}


// WEBPACK FOOTER //
// ./modules/lib/reducers/ReducerTemplates.js